import { w } from 'windstitch';

export const Wrapper = w.div(
  'w-full px-4 lg:px-8 relative',
);

export const ContentBox = w.div(
  'flex flex-col items-center text-center w-full bg-[var(--azul-escuro)] rounded-xl text-white p-8 md:p-12',
);

export const Title = w.h1(
  'text-4xl md:text-5xl'
);

export const SubText = w.p(
  'text-xl mt-4 mb-20'
);

export const Image = w.img(
  'w-full'
);
